var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58.3333,
    height: 40,
    rx: 4,
    fill: "#EBF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9569 26.8046H21.6586L23.7216 14.0486H27.0197L24.9569 26.8046Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9122 14.3607C36.2616 14.1026 35.2298 13.8176 33.9539 13.8176C30.6967 13.8176 28.403 15.5545 28.3889 18.0378C28.3619 19.8699 30.0312 20.8875 31.2796 21.4984C32.5557 22.1226 32.9895 22.5301 32.9895 23.0865C32.9765 23.941 31.9583 24.335 31.0087 24.335C29.6919 24.335 28.9863 24.1319 27.9141 23.6564L27.4797 23.4526L27.0182 26.3161C27.7918 26.6685 29.217 26.9812 30.6967 26.995C34.1575 26.995 36.4106 25.2849 36.4373 22.6386C36.4505 21.1865 35.569 20.0739 33.6687 19.1647C32.5151 18.581 31.8086 18.1875 31.8086 17.5903C31.8222 17.0474 32.4062 16.4913 33.7084 16.4913C34.7807 16.4641 35.5685 16.7218 36.1653 16.9798L36.4636 17.1152L36.9122 14.3607Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2977 22.2856C41.5693 21.5528 42.6145 18.7166 42.6145 18.7166C42.6008 18.7438 42.8856 17.9702 43.0485 17.4953L43.279 18.5945C43.279 18.5945 43.9036 21.6478 44.0392 22.2856C43.5238 22.2856 41.9492 22.2856 41.2977 22.2856ZM45.3691 14.0486H42.8178C42.0311 14.0486 41.4333 14.2791 41.0939 15.107L36.1947 26.8044H39.6555C39.6555 26.8044 40.2253 25.23 40.3477 24.8909C40.7274 24.8909 44.0941 24.8909 44.5825 24.8909C44.6772 25.3388 44.976 26.8044 44.976 26.8044H48.0299L45.3691 14.0486Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9033 14.0486L15.6732 22.747L15.3203 20.9828C14.7231 18.9472 12.8502 16.7356 10.7601 15.636L13.7188 26.7911H17.2067L22.391 14.0486H18.9033Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6738 14.0486H7.36716L7.31287 14.3063C11.4524 15.3649 14.1939 17.9165 15.3203 20.9834L14.1667 15.1208C13.9767 14.3061 13.3931 14.0755 12.6738 14.0486Z",
    fill: "#FAA61A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.29a5c156ab560a0a957d248054a7060e.svg";
export { ForwardRef as ReactComponent };